import styles from './index.module.sass'

const LoadingIndicator = () => {
  return (
    <div className={styles.loadingIndicator}/>
  )
}

export default LoadingIndicator
